<template>
  <Confirmation title="Formulaire soumis" :idFacture="idFacture" :hideAppbar="hideAppbar" :message="message">
    <ressource code="formulaire-soumis"></ressource>
  </Confirmation>
</template>

<script>
import Confirmation from "@/components/Common/Confirmation"
export default {
  components: { Confirmation },
  props: {
    idFacture: { type: String },
    hideAppbar: { type: Boolean, default: false },
    message: String
  }
}
</script>